import { useFlags } from "features/api/flags"

export function useIsNativeLoyaltyEnabled(): {
  isNativeLoyaltyEnabled: boolean
  isLoading: boolean
} {
  const { ENABLE_NATIVE_LOYALTY, isLoading } = useFlags()
  return {
    isNativeLoyaltyEnabled: ENABLE_NATIVE_LOYALTY.boolVal,
    isLoading,
  }
}
